module.exports = __webpack_public_path__ + "static/media/plugPositivePlugged.403a2ae6.svg";